import type {
  CategoryWithSelectedProduct,
  CategoryWithSelectedProductRequired,
} from "@/features/products/models";

export const getPricesIds = (
  selectedCategories: CategoryWithSelectedProduct[],
) => {
  const filteredCategories = selectedCategories.filter(
    (category) => category.selectedProduct?.selectedPrice,
  ) as CategoryWithSelectedProductRequired[];

  return filteredCategories.map(
    (category) => category.selectedProduct.selectedPrice.id,
  );
};
